import { authHeader,logout, handleResponse } from '../helpers';
import Vue from 'vue';


export const certifikatService = {
    load,loadAll,loadLastYear,save,remove,isci,vrniPoId,
    
};
function isci(isci) {
    const requestOptions = {
        method: 'GET',
        //headers:authHeader(),
        
    };
return fetch(`${Vue.prototype.$config.apiUrl}/javno/certifikat/?isci=${isci}`, requestOptions)
        .then(handleResponse)
        .then(certifikat => {
            // login successful if there's a jwt token in the response
            
            return certifikat;
        });
}


function vrniPoId(id) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
    
    };
return fetch(`${Vue.prototype.$config.apiUrl}/pridelava/pridelovalec/certifikat/id/?id=${id}`, requestOptions)
        .then(handleResponse)
        .then(certifikat => {

            
            return certifikat;
        });
}



function load(sezona,pridelovalecid) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/pridelava/pridelovalec/certifikat/?sezona=${sezona}&pridelovalecid=${pridelovalecid}`, requestOptions)
        .then(handleResponse)
        .then(certifikat => {
            // login successful if there's a jwt token in the response
            
            return certifikat;
        });
}


function save(certifikat) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json',...authHeader()},
        body: JSON.stringify(certifikat)
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/pridelava/pridelovalec/certifikat`, requestOptions).then(handleResponse);
}


function remove(certifikat) {
    const requestOptions = {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json',...authHeader()},
        body: JSON.stringify(certifikat)
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/pridelava/pridelovalec/certifikat`, requestOptions).then(handleResponse);
}

function loadAll(sezona){
  const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


     return fetch(`${Vue.prototype.$config.apiUrl}/pridelava/certifikati/?sezona=${sezona}`, requestOptions)
        .then(handleResponse)
        .then(certifikat => {
            // login successful if there's a jwt token in the response
            
            return certifikat;
        });
}

function loadLastYear(gerk,status){
    //in tu lahko napišem pravila ali pa jih enostavno potegnem iz baze preko api-ja
    return fetch(`${Vue.prototype.$config.apiUrl}/pridelava/pridelovalec/certifikat/?sezona=${sezona}&pridelovalecid=${pridelovalecid}`, requestOptions)
        .then(handleResponse)
        .then(certifikat => {
            // login successful if there's a jwt token in the response
            
            return certifikat;
        });

}
